(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-counter-need-details"] && !Shopify.designMode) return;
  try {
    
  function initializeGiftCounterNeedDetails() {
    document.querySelectorAll('[data-gift-need-details]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const intro = root.querySelector('[data-gift-need-empty]');
      const panels = Array.from(root.querySelectorAll('[data-gift-need-detail]'));

      document.addEventListener('gift-counter:need', (event) => {
        let selectedPanel = null;

        panels.forEach((panel) => {
          const isSelected = panel.dataset.giftNeedDetail === event.detail.need;
          panel.hidden = !isSelected;
          if (isSelected) selectedPanel = panel;
        });

        intro.hidden = selectedPanel !== null;
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  initializeGiftCounterNeedDetails();
  document.addEventListener('shopify:section:load', initializeGiftCounterNeedDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-counter-needs"] && !Shopify.designMode) return;
  try {
    
  function initializeGiftCounterNeeds() {
    document.querySelectorAll('.gift-counter-needs__grid').forEach((needsList) => {
      if (needsList.dataset.initialized === 'true') return;
      needsList.dataset.initialized = 'true';

      needsList.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gift-need]');
        if (!button) return;

        needsList.querySelectorAll('[data-gift-need]').forEach((item) => {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });

        document.dispatchEvent(new CustomEvent('gift-counter:need', { detail: { need: button.dataset.giftNeed } }));
      });
    });
  }

  initializeGiftCounterNeeds();
  document.addEventListener('shopify:section:load', initializeGiftCounterNeeds);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-counter-products"] && !Shopify.designMode) return;
  try {
    
  function initializeGiftCounterProducts() {
    document.querySelectorAll('[data-gift-products]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const state = { scene: 'all', budget: 'all' };
      const groups = Array.from(root.querySelectorAll('[data-gift-product-group]'));
      const budgetButtons = Array.from(root.querySelectorAll('[data-gift-budget]'));
      const empty = root.querySelector('[data-gift-empty]');

      const bucketFor = (price) => {
        if (price <= 200000) return 'under2000';
        if (price <= 399900) return '2000to3999';
        if (price <= 599900) return '4000to5999';
        return 'over6000';
      };

      const applyFilters = () => {
        let visibleGroups = 0;

        groups.forEach((group) => {
          const sceneMatches = state.scene === 'all' || group.dataset.giftProductGroup === state.scene;
          let visibleProducts = 0;

          group.querySelectorAll('[data-gift-product]').forEach((product) => {
            const budgetMatches = state.budget === 'all' || bucketFor(Number(product.dataset.price)) === state.budget;
            product.hidden = !budgetMatches;
            if (budgetMatches) visibleProducts += 1;
          });

          group.hidden = !sceneMatches || visibleProducts === 0;
          if (!group.hidden) visibleGroups += 1;
        });

        empty.hidden = visibleGroups > 0;
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gift-budget]');
        if (!button) return;

        state.budget = button.dataset.giftBudget;
        budgetButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        applyFilters();
      });

      document.addEventListener('gift-counter:scene', (event) => {
        state.scene = event.detail.scene;
        applyFilters();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  initializeGiftCounterProducts();
  document.addEventListener('shopify:section:load', initializeGiftCounterProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-counter-scenes"] && !Shopify.designMode) return;
  try {
    
  function initializeGiftCounterScenes() {
    document.querySelectorAll('[data-gift-scenes]').forEach((sceneList) => {
      if (sceneList.dataset.initialized === 'true') return;
      sceneList.dataset.initialized = 'true';

      sceneList.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gift-scene]');
        if (!button) return;

        sceneList.querySelectorAll('[data-gift-scene]').forEach((item) => {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });

        document.dispatchEvent(new CustomEvent('gift-counter:scene', { detail: { scene: button.dataset.giftScene } }));
      });
    });
  }

  initializeGiftCounterScenes();
  document.addEventListener('shopify:section:load', initializeGiftCounterScenes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-week-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('silver-week-popup')) {
    customElements.define('silver-week-popup', class extends HTMLElement {
      connectedCallback() {
        this.storageKey = `${this.dataset.campaignKey}:dismissed`;
        this.dismissed = false;
        try { this.dismissed = sessionStorage.getItem(this.storageKey) === 'true'; } catch (_) { /* Storage may be unavailable. */ }
        this.onClose = () => {
          this.dismissed = true;
          this.hidden = true;
          clearTimeout(this.timer);
          try { sessionStorage.setItem(this.storageKey, 'true'); } catch (_) { /* Closing still works without storage. */ }
        };
        this.onVisibility = () => this.updateVisibility();
        this.closeButton = this.querySelector('[data-silver-week-close]');
        this.closeButton.addEventListener('click', this.onClose);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.updateVisibility();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.closeButton?.removeEventListener('click', this.onClose);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      updateVisibility() {
        clearTimeout(this.timer);
        const startValue = this.dataset.startsAt.trim();
        const startsAt = startValue ? Date.parse(startValue) : 0;
        const endsAt = Date.parse(this.dataset.endsAt);
        const now = Date.now();
        if (this.dismissed || !Number.isFinite(startsAt) || !Number.isFinite(endsAt) || startsAt >= endsAt || now >= endsAt) {
          this.hidden = true;
          return;
        }
        this.hidden = now < startsAt;
        const nextBoundary = now < startsAt ? startsAt : endsAt;
        this.timer = setTimeout(() => this.updateVisibility(), Math.min(nextBoundary - now, 2147483647));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
